/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const PatchClusterUpgrade = {
  id: 'cluster-upgrade.patch',
  tag: 'Cluster',
  summary: 'Upgrade a cluster PostgreSQL version',
  description: 'Upgrade a cluster PostgreSQL version within an organization project',
  method: 'patch',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/upgrade`,
  request: {
    params: Params,
    query: z.strictObject({ schedule: z.coerce.boolean() }),
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
